"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _saraivaUi = require("@minha-biblioteca/saraiva-ui");
var _themes = require("../../themes");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/jsx-no-bind */

function ColorPopover(props) {
  var {
    open,
    highlight,
    onChangeColor,
    onClose
  } = props;
  var [currentHighlight, setCurrentHighlight] = (0, _react.useState)();
  var classes = (0, _styles.default)();
  (0, _react.useEffect)(() => {
    if (highlight) setCurrentHighlight(highlight);
  }, [highlight, setCurrentHighlight]);
  function renderColors() {
    var currentColor = currentHighlight === null || currentHighlight === void 0 ? void 0 : currentHighlight.color;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.container
    }, currentColor !== _themes.COLORS.GREEN && /*#__PURE__*/_react.default.createElement(_saraivaUi.CardSelect, {
      label: "Verde",
      backgroundColor: _themes.HIGHLIGHT_COLORS.green,
      onClick: () => onChangeColor(currentHighlight, _themes.COLORS.GREEN)
    }), currentColor !== _themes.COLORS.YELLOW && /*#__PURE__*/_react.default.createElement(_saraivaUi.CardSelect, {
      label: "Amarelo",
      backgroundColor: _themes.HIGHLIGHT_COLORS.yellow,
      onClick: () => onChangeColor(currentHighlight, _themes.COLORS.YELLOW)
    }), currentColor !== _themes.COLORS.RED && /*#__PURE__*/_react.default.createElement(_saraivaUi.CardSelect, {
      label: "Vermelho",
      backgroundColor: _themes.HIGHLIGHT_COLORS.red,
      onClick: () => onChangeColor(currentHighlight, _themes.COLORS.RED)
    }), currentColor !== _themes.COLORS.PURPLE && /*#__PURE__*/_react.default.createElement(_saraivaUi.CardSelect, {
      label: "Roxo",
      backgroundColor: _themes.HIGHLIGHT_COLORS.purple,
      onClick: () => onChangeColor(currentHighlight, _themes.COLORS.PURPLE)
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_saraivaUi.Dialog, {
    handleClose: onClose,
    handleConfirm: onClose,
    primaryButton: "FECHAR",
    title: "Alterar Cor",
    size: "xs",
    open: open
  }, renderColors());
}
ColorPopover.propTypes = {
  open: _propTypes.default.bool,
  highlight: _propTypes.default.shape({
    id: _propTypes.default.number,
    textHighlighted: _propTypes.default.string,
    textReference: _propTypes.default.string,
    annotation: _propTypes.default.string,
    color: _propTypes.default.string
  }),
  onChangeColor: _propTypes.default.func.isRequired,
  onClose: _propTypes.default.func.isRequired
};
ColorPopover.defaultProps = {
  open: false,
  highlight: null
};
var _default = exports.default = ColorPopover;